import BaseAPI from '@/apis/base'
import { apis, getApiUrl } from '../api-config'

class SchoolYearAPI extends BaseAPI {}

export default new SchoolYearAPI('v1/school-years', 'SchoolYear', getApiUrl(apis.CommonAPI))
